import RankHR_DashboardPage from "@RankHR/Regions/Pages/DashboardPage.vue";
import RankHR_SurveyPage from "@RankHR/Regions/Pages/SurveyPage.vue";
import RankHR_OverallReportPage from "@RankHR/Regions/Pages/OverallReportPage.vue";
import RankHR_IndividualReportPage from "@RankHR/Regions/Pages/IndividualReportPage.vue";

export const routes = [
    {
        path: "/rankhr/:id",
        component: RankHR_DashboardPage
    },
    {
        path: "/rankhr/survey/:id/:votingCycle?",
        component: RankHR_SurveyPage
    },
    {
        path: "/rankhr/overallreport/:id",
        component: RankHR_OverallReportPage
    },
    {
        path: "/rankhr/individualreport/:id/:votingCycle?",
        component: RankHR_IndividualReportPage
    }
]
